export default __webpack_public_path__ + "static/media/dark7.f9b8dca5.png";